import React from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css';
import rollDinamitaImage from '../assets/Tipos de Rolls/ROLL Camaron - Dinamita.png';

const AboutUs = () => {
  return (
    <section className="about-us">
      <div className="container">
        <div className="breadcrumb">
          <Link to="/">INICIO</Link>
          <span> / </span>
          <span>NOSOTROS</span>
        </div>

        <h1 className="about-us-title">SOBRE NOSOTROS</h1>

        <div className="about-us-content-top">
          <div className="about-us-text-box">
            <h2 className="about-us-subtitle">Quiénes somos?</h2>
            <div className="about-us-text-content">
              <p>
                CHEF MARGARO ES UNA EMPRESA DE SUSHI QUE NACE COMO UN EMPRENDIMIENTO CASERO EN SAN DIEGO, CARABOBO, VENEZUELA. DESDE SUS INICIOS, NUESTRO OBJETIVO HA SIDO OFRECER UN CONCEPTO DIFERENTE DE SUSHI, CON UN TAMAÑO MAYOR, FULL DE PROTEÍNAS Y A UN PRECIO ACCESIBLE PARA UN TARGET AMPLIO.
                <br /><br />
                NUESTRA PASIÓN POR LA COMIDA Y EL SUSHI EN PARTICULAR, NOS LLEVÓ A CREAR UNA MARCA QUE SE DIFERENCIA POR LA CALIDAD DE SUS PRODUCTOS Y SU ATENCIÓN AL CLIENTE. EN CHEF MARGARO, NOS ESFORZAMOS POR BRINDAR UNA EXPERIENCIA ÚNICA A NUESTROS CLIENTES, DONDE NO SOLO SE TRATA DE COMER SUSHI, SINO DE DISFRUTAR DE UNA COMIDA DELICIOSA EN UN AMBIENTE AGRADABLE.
                <br /><br />
                A MEDIDA QUE CRECIMOS, NUESTRA REPUTACIÓN SE EXTENDIÓ POR DIVERSOS MUNICIPIOS Y NOS LLEVÓ A ABRIR NUEVAS SEDES EN MARACAY Y CARACAS. HOY EN DÍA, SOMOS RECONOCIDOS COMO UNA MARCA LÍDER EN LA INDUSTRIA DEL SUSHI EN VENEZUELA, Y SEGUIMOS TRABAJANDO DURO PARA MANTENER LA EXCELENCIA EN TODO LO QUE HACEMOS.
                <br /><br />
                PERO LO QUE NOS HACE REALMENTE ESPECIALES, ES NUESTRO COMPROMISO CON NUESTROS CLIENTES. EN CHEF MARGARO, CREEMOS QUE EL SUSHI NO TIENE POR QUÉ SER CARO PARA SER BUENO. POR ESO, NOS ESFORZAMOS POR OFRECER PRECIOS ACCESIBLES PARA QUE TODOS PUEDAN DISFRUTAR DE NUESTRA DELICIOSA COMIDA.
              </p>
              {/* <p>
                Actualmente también estamos presentes en Caracas bajo la modalidad de solo delivery.
              </p> */}
            </div>
          </div>
          <div className="about-us-image-container">
            <img
              src={rollDinamitaImage}
              alt="Sushi dishes"
              className="about-us-image"
            />
          </div>
        </div>

        <div className="about-us-content-bottom">
          <div className="about-us-mission">
            <div className="about-us-overlay"></div>
            <div className="about-us-overlay-content">
              <h2 className="about-us-overlay-title">Nuestra misión</h2>
              <p className="about-us-overlay-text">
              Somos una empresa gastronómica con un concepto diferente de sushi, que busca garantizar: excelente calidad, buen tamaño, precio accesible y un adecuado equilibrio en sus ingredientes, sumando un rápido y esmerado servicio.  
              </p>
            </div>
          </div>
          <div className="about-us-proposal">
            <div className="about-us-overlay"></div>
            <div className="about-us-overlay-content">
              <h2 className="about-us-overlay-title">Nuestra visión</h2>
              <p className="about-us-overlay-text">
              Convertirnos en una organización posicionada en el mercado de sushi, brindando un sistema de franquicias bien estructurada, con un ambiente familiar divertido y amigable, tanto a nivel nacional como internacional, ofreciendo una experiencia innovadora por su excelente atención y rapidez en el servicio, contribuyendo con actividades al desarrollo del país.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;

